<template>
    <div>
        <div class=" bg-blue-500 text-white p-20">
           <div class=" text-center ">
               <p class=" text-3xl font-poppins font-semibold">Why Use CarryGo?</p>
               <p class="w-1/3 m-auto mt-6 font-poppins lg:w-full ">Your gateway to seamless, fast, and flexible delivery to customers.</p>
           </div>

           <div class="  flex justify-center mt-16 font-montserrat md:flex-col ">
               <div class=" w-1/4 text-center mr-10 lg:w-full   ">
                   <!-- <img class="m-auto" src="../Images/img1.svg " alt="image"> -->
                   <i class=" fa fa-clock border p-4 fa-2x bg-white text-blue-700 rounded-3xl"></i>
                   <p class="mt-4 mb-4 font-semibold">Fast</p>
                   <p >
                    Time is of great essence to us at CarryGo hence our motto; "Delivery at the speed of thought". let's help you save cost today.
                   </p>
               </div>

               <div class=" w-1/4 text-center mr-10 lg:w-full md:mt-16 ">
                   <i class=" fa fa-handshake border p-4 fa-2x bg-white text-blue-700 rounded-3xl"></i>
                   <p class="mt-4 mb-4 font-semibold">Reliable</p>
                   <p class="md:w-full">
                       A Delivery Service you can always count on. We prove it time after time with every delivery done.
                   </p>
               </div>

               <div class=" w-1/4 text-center mr-10 lg:w-full  md:mt-16">
                   <i class=" fa fa-lock border p-4 fa-2x bg-white text-blue-700 rounded-3xl"></i>
                   <p class="mt-4 mb-4 font-semibold">Secure</p>
                   <p>
                       We guarantee the safety of your goods by implementing standard practice that promote health and safety in our operations,
                       comprehensive  insurance for goods and professional training of our CG Carriers. 
                   </p>
               </div>
           </div>
       </div>
    </div>
</template>